import React, {Component} from 'react';
import Section from '../section/section';
import sidebarStyles from './sidebar.module.scss'
import Search from "../search/search";


class Sidebar extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      activeSection: props.activeSection,
    };
  }

  toggleSection(section) {
    this.setState(state => ({
      activeSection: state.activeSection === section ? null : section,
    }));
  }

  render() {
    const {createLink, sectionList, location} = this.props;

    const {activeSection} = this.state;

    return (
        <div id='sidebar' className={sidebarStyles.sidebar}>
          <Search location={location}/>

          {sectionList.map((section, index) => (
              <Section
                  createLink={createLink}
                  isActive={activeSection === section}
                  key={index}
                  location={location}
                  onSectionTitleClick={() => this.toggleSection(section)}
                  section={section}
              />
          ))}
        </div>
    );
  }

}

export default Sidebar;
